import $ from 'jquery';
import BasePropertyView from 'BasePropertyView.js';
import contentTemplate from 'properties/navigation/tooltip.ejs';
import util from 'util/Util';

class NavTooltipView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=text]' : 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus'
        };

        //this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = util.sanitizeHTML(ev.currentTarget.value, true, this.model.get(propName));

        this.model.set( propName, propVal );
    }

    render() {

        this.$el.empty();
        this.$el.html(this.template(this.model.toJSON()));

        this.delegateEvents();
        return this;
    }

}

export default NavTooltipView;
